import { render, staticRenderFns } from "./TempCardForMember.vue?vue&type=template&id=00cdde51&"
import script from "./TempCardForMember.vue?vue&type=script&lang=js&"
export * from "./TempCardForMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports